module.exports = __webpack_public_path__ + "static/media/4.question.3bc395d1.mp4";